import { GET } from "../../APiHelper/API";

export const getDeletedPlayersAPI = (team_id, onSuccess, onError) => {


    GET(`/api/v1/leagues/team/${team_id}/deleted_players`, onSuccess, onError)
}